// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Rl_X","consentsList":"PatientConsents_consentsList__11fBr","consentsListEmpty":"PatientConsents_consentsListEmpty__2vKuf"};